import { DataBean } from "../DataBean";

export class LoanAccountantConcept extends DataBean{


    public async getLoanAccountantConceptCatalog(idLoanLine:any):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getLoanAccountantConceptCatalog_Number",[idLoanLine]);
    }
}